var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { droparea, placeholder, placeholderContent } from '../styles';
import { droparea as dropareaCitron, placeholder as placeholderCitron, placeholderContent as placeholderContentCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Droparea = citrusStyled.div('droparea', { legacy: droparea, citrus2022: dropareaCitron });
export var Placeholder = citrusStyled.div('placeholder', { legacy: placeholder, citrus2022: placeholderCitron });
export var PlaceholderContent = citrusStyled.div('placeholderContent', {
    legacy: placeholderContent,
    citrus2022: placeholderContentCitron,
});
export var DropareaPlaceholder = function (_a) {
    var placeholderText = _a.placeholderText, other = __rest(_a, ["placeholderText"]);
    return (React.createElement(Placeholder, __assign({}, other),
        React.createElement(PlaceholderContent, null, placeholderText)));
};
export var Styled = {
    Droparea: Droparea,
    DropareaPlaceholder: DropareaPlaceholder,
};
